import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PackageService } from 'src/app/private/services/package.service';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-delete-package',
  imports: [SharedModule],
  templateUrl: './delete-package.component.html',
  styleUrl: './delete-package.component.scss'
})
export class DeletePackageComponent {

  @Output() close = new EventEmitter<void>();
  @Input() selectedPackage: any = null;
  @Output() reload = new EventEmitter<void>();
  loading = false;

  constructor(
    private packageService: PackageService
  ) {}

  handleCloseDialog() {
    this.close.emit();
  }

  deletePackage() {

    const payload = {
      package_id: this.selectedPackage.package_id,
    }

    this.loading = true;
    this.packageService.deletePackage(payload).subscribe({
      next: (res) => {
        this.loading = false;
          this.reload.emit();
          this.close.emit();
      },
      error: (err) => {
        this.loading = false;
      }
    });
  }

}
